export enum TelematicsRoutePointStatus {
  PLANNED = 'planned',
  ASSIGNED = 'assigned',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}
